import { Card, CardContent } from "@/components/ui/card";
const principles = [{
  sanskrit: "Pravo na pristup i informiranost",
  english: "Imate pravo dobiti potvrdu obrađuju li se vaši podaci te pristupiti svim osobnim informacijama koje čuvamo."
}, {
  sanskrit: "Pravo na ispravak i dopunu",
  english: "U svakom trenutku možete zatražiti ispravak netočnih podataka ili dopunu nepotpunih informacija o vama."
}, {
  sanskrit: "Pravo na zaborav i brisanje",
  english: "Možete zahtijevati trajno brisanje vaših osobnih podataka kada oni više nisu nužni za svrhu u koju su prikupljeni."
}, {
  sanskrit: "Prenosivost i povlačenje privole",
  english: "Imate pravo na prijenos podataka drugom voditelju obrade te pravo na povlačenje privole u bilo kojem trenutku."
}];
export default function GuidingPrinciples() {
  return <section data-section-id="256493" id="korisnička-prava" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-default font-bold text-center text-foreground mb-12">
          Vaša prava na privatnost
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {principles.map((principle, i) => <Card key={i} data-index={i} className="bg-card border-border shadow-md rounded-lg pt-8 pb-8 px-0 transition-shadow hover:shadow-lg">
              <CardContent className="px-6 text-center flex flex-col items-center justify-start h-full gap-4">
                <p className="text-primary font-default font-semibold text-lg">
                  {principle.sanskrit}
                </p>
                <p className="text-muted-foreground font-default text-sm leading-relaxed">
                  {principle.english}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}